<template>
  <div>
    <HMModalHeader
      :title="$t('MEDIA_LIBRARY.TITLE.INSTRUCTOR_DETAILS')"
      @close="$emit('close')"
    />
    <div class="text-center">
      <HMPhotoIcon class="mb-3" :instructor="instructorLocal" size="150px" />
      <h2 class="mb-3">{{ instructorLocal.name }}</h2>
      <p v-html="getInstructorBio"></p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  name: 'InstructorDetailsModal',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
    getInstructorBio() {
      if (!this.instructorLocal) return '';
      if (this.instructorLocal.bio_new)
        return sanitize(this.instructorLocal.bio_new.replace(/\n/g, '<br/>'));

      return sanitize(this.instructorLocal.bio);
    },
  },
  data() {
    return {
      instructorLocal: this.instructor,
    };
  },
  async mounted() {
    const studioURL = this.studioURL;
    const instructorId = this.instructor.id;
    this.instructorLocal = await this.$store.dispatch(
      'product/getStudioInstructor',
      { studioURL, instructorId }
    );
  },
});
</script>

<style scoped></style>
